type BrandType = {
  name: string;
  domainName: string;
  portalLink: string;
};

export const BRANDS: Record<string, BrandType> = {
  localhost: {
    name: 'CacheFly',
    domainName: 'https://cachefly.com',
    portalLink: 'https://portal.cachefly.com',
  },
  'portal.cachefly.com': {
    name: 'CacheFly',
    domainName: 'https://cachefly.com',
    portalLink: 'https://portal.cachefly.com',
  },
  'portal-dev.cachefly.com': {
    name: 'CacheFly',
    domainName: 'https://cachefly.com',
    portalLink: 'https://portal.cachefly.com',
  },
  'portal.instantcdn.com': {
    name: 'CDN',
    domainName: 'https://instantcdn.com',
    portalLink: 'https://portal.instantcdn.com',
  },
  'dashboard.viewtvx.net': {
    name: 'View TV Network',
    domainName: 'https://viewtvx.com',
    portalLink: 'https://dashboard.viewtvx.net',
  },
};

export const BRAND: string =
  BRANDS[window.location.hostname]?.name || BRANDS['portal.cachefly.com'].name;
export const DOMAIN_NAME =
  BRANDS[window.location.hostname]?.domainName ||
  BRANDS['portal.cachefly.com'].domainName;
export const PORTAL_LINK =
  BRANDS[window.location.hostname]?.portalLink ||
  BRANDS['portal.cachefly.com'].portalLink;

const brand = BRAND.toLowerCase().replace(/\s+/g, '');

export const TEXT = (text = '') => {
  return text
    .replace('api.cachefly.com/api/2.6/docs', 'portal.cachefly.com/api/2.6/docs')
    .replace(/CacheFly/gi, BRAND);
};

export const CACHE_NETWORKS = 'CacheNetworks, LLC';

export const isCacheFly = BRAND === 'CacheFly';
//   window.location.hostname.includes('cachefly.com') ||
//   window.location.hostname.includes('localhost');

export const logoFullWhite = () => {
  if (BRAND === 'View TV Network') {
    return `/assets/images/${brand}/logo-full-white.png`;
  }
  return `/assets/images/${brand}/logo-full-white.svg`;
};

export const logoFullDark = () => {
  return `/assets/images/${brand}/logo-full-dark.svg`;
};

export const logoSmallWhite = () => {
  return `/assets/images/${brand}/logo-small-white.svg`;
};

export const logoSmallDark = () => {
  return `/assets/images/${brand}/logo-small-dark.svg`;
};
